import { timeline } from '@/mocks/home';

export default function Timeline() {
  return (
    <section id="timeline" className="relative w-full overflow-hidden bg-background-950 py-14 md:py-20">
      <div className="pointer-events-none absolute inset-0 opacity-[0.06]">
        <i className="ri-fire-fill absolute -left-10 top-10 text-[300px]" />
        <i className="ri-fire-fill absolute -bottom-16 -right-10 text-[320px]" />
      </div>

      <div className="relative mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <span className="inline-flex items-center gap-1.5 text-xs font-semibold tracking-widest text-accent-400">
              <i className="ri-broadcast-line" /> TIMELINE
            </span>
            <h2 className="mt-1 font-heading text-2xl font-black text-background-50 md:text-3xl">
              今晚劲爆时间轴
            </h2>
          </div>
          <p className="max-w-md text-xs leading-relaxed text-background-200/70 md:text-sm">
            高能事件按时间线逐段拆解，从瓜点到反转一帧不落地串成完整脉络。
          </p>
        </div>

        <div className="relative mt-9 border-l border-background-50/15 pl-6 md:ml-3 md:pl-10">
          <div className="absolute -left-[5px] top-1 h-2.5 w-2.5 rounded-full bg-accent-500" />
          {timeline.map((item, idx) => (
            <article key={item.time} className="group relative pb-8 last:pb-0">
              <span
                className={`absolute -left-[calc(1.5rem+5px)] top-1.5 h-2.5 w-2.5 rounded-full md:-left-[calc(2.5rem+5px)] ${
                  idx === 0 ? 'bg-primary-500 ring-4 ring-primary-500/20' : 'bg-background-200'
                }`}
              />
              <div className="grid grid-cols-1 gap-4 sm:grid-cols-12 sm:items-center">
                <div className="sm:col-span-3 lg:col-span-2">
                  <span className="font-heading text-2xl font-black text-accent-400 md:text-3xl">{item.time}</span>
                  <span className="mt-1 block text-xs font-medium text-background-200/60">
                    {item.tag} · 更新
                  </span>
                </div>
                <div className="sm:col-span-9 lg:col-span-6">
                  <h3 className="text-base font-bold text-background-50 group-hover:text-accent-300 md:text-lg">
                    {item.title}
                  </h3>
                  <p className="mt-1.5 text-xs leading-relaxed text-background-200/75 md:text-sm">
                    {item.detail}
                  </p>
                </div>
                <div className="sm:col-span-12 lg:col-span-4">
                  <div className="overflow-hidden rounded-md border border-background-50/10">
                    <img
                      src={item.pic}
                      alt={item.title}
                      className="aspect-[16/10] w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}